/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_baseUnary.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_baseUnary.js
// module chunks = 1